import { render, staticRenderFns } from "./AdminConfigureConnectorPage.vue?vue&type=template&id=37330916"
import script from "./AdminConfigureConnectorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminConfigureConnectorPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports